'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Search(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M741.216 695.968l192.896 192.864a31.968 31.968 0 1 1-45.28 45.28L695.968 741.216A382.464 382.464 0 0 1 448 832C235.936 832 64 660.064 64 448S235.936 64 448 64s384 171.936 384 384c0 94.528-34.144 181.056-90.784 247.968zM448 768c176.736 0 320-143.264 320-320S624.736 128 448 128 128 271.264 128 448s143.264 320 320 320z' })
  );
}
Search.displayName = 'Search';

module.exports = Search;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/search.js
// module id = 210
// module chunks = 0